<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <h1>Tenant Intake Form Successfully Submitted</h1>
        <callout type="info">
          Your intake form has been successfully submitted. Your case number is {{ applicantId }}. Please make a note of it as you will need it in the future to check the status of this case. For questions, call the Diversion Tenant Hotline Mon-Fri 9AM-4PM at <a href="tel:215-523-9501"><u>215-523-9501</u></a>. 
        </callout>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TenantSuccessPage",
  props: {
    applicantId: {
      default: null,
      type: String,
    },
  },
};
</script>